// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ComponentJobsJobFragmentDoc } from './ComponentJobsJob.fragment.generated';
export const ComponentJobsFragmentDoc = gql`
    fragment componentJobs on ComponentJobs {
  jobs {
    ...componentJobsJob
  }
}
    ${ComponentJobsJobFragmentDoc}`;